import { colors } from '@mui/material';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  root: {
    borderRadius: 3,
    overflow: 'hidden'
  },
  colorPrimary: {
    backgroundColor: colors.blueGrey[50]
  }
};
